import React, { useContext, useEffect } from "react";
import { BuildAbsoluteUrl } from "../utils/urlBuilder";
import { useMetaContext } from './HeadMetaTags';

const SeoBlock = ({routeData}) => {

    const {canonical_url, meta_title, meta_keywords, meta_description, url_key} = routeData;
    let baseImage='https://s3.emmezeta.hr/media/emmezeta.png';
    const canonicalUrl = BuildAbsoluteUrl(canonical_url ? canonical_url : url_key);

    switch (routeData.__typename) {
        case 'CategoryTree':
            const storePath = routeData.current_store_paths && routeData.current_store_paths[0];
            const baseUrlImage = storePath && storePath.base_url_image;
            if (baseUrlImage) {
                baseImage = baseUrlImage
            }
            break;
        case 'SimpleProduct':
            case 'GroupedProduct':
                const {
                    gallery
                } = routeData || {};

                const firstImage = gallery && gallery.length && gallery.reduce((prev, curr) => (prev.position < curr.position ? prev : curr));
                const image =
                    firstImage && (firstImage.large_image_url || firstImage.medium_image_url || firstImage.small_imgage_url);
                if (image) {
                    baseImage = image;
                }
                break;
            case 'CmsPage':
                break;
        }
    // Użyj kontekstu metadanych zamiast Helmet
    const metaContext = useMetaContext();
    
    // Aktualizuj metadane, gdy dane routeData się zmieniają
    useEffect(() => {
        if (typeof window !== 'undefined' && metaContext && routeData) {
            // Przygotuj meta tagi
            const meta = [];
            const links = [];
            
            if (meta_title) {
                document.title = meta_title;
            }
            
            if (meta_title) meta.push({ property: "og:title", content: meta_title });
            if (meta_keywords) meta.push({ property: "og:keywords", content: meta_keywords });
            if (meta_description) meta.push({ property: "og:description", content: meta_description });
            if (canonicalUrl) meta.push({ property: "og:url", content: canonicalUrl });
            if (baseImage) meta.push({ property: "og:image", content: baseImage });
            
            if (meta_description) meta.push({ name: "description", content: meta_description });
            if (meta_keywords) meta.push({ name: "keywords", content: meta_keywords });
            
            if (canonicalUrl) links.push({ rel: "canonical", href: canonicalUrl });
            
            // Aktualizuj metadane
            meta.forEach(({ name, property, content }) => {
                let selector = '';
                if (name) selector = `meta[name="${name}"]`;
                else if (property) selector = `meta[property="${property}"]`;
                
                if (!selector) return;
                
                let element = document.querySelector(selector);
                if (!element) {
                    element = document.createElement('meta');
                    if (name) element.setAttribute('name', name);
                    if (property) element.setAttribute('property', property);
                    document.head.appendChild(element);
                }
                
                element.setAttribute('content', content || '');
            });
            
            // Aktualizuj linki
            links.forEach(({ rel, href }) => {
                let element = document.querySelector(`link[rel="${rel}"][href="${href}"]`);
                if (!element) {
                    element = document.createElement('link');
                    element.setAttribute('rel', rel);
                    element.setAttribute('href', href);
                    document.head.appendChild(element);
                }
            });
        }
    }, [routeData, meta_title, meta_description, meta_keywords, canonicalUrl, baseImage]);
    
    // Ten komponent nie renderuje nic w widoku
    return null;
}

export default SeoBlock